exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upload-preview[data-v-0758ec59] {\n  text-align: center;\n  max-width: 200px;\n  border: 1px solid #ddd;\n  padding: 10px;\n  position: relative;\n}\n.upload-preview img[data-v-0758ec59] {\n    max-width: 200px;\n    margin: 0 auto;\n}\n.text-ellipsis[data-v-0758ec59] {\n  display: inline-block;\n  width: 90%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-0758ec59","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/theme.scss","/data/wwwroot/shop.yaoking.cn/build/espier-retail-manage/app/src/style/_mixin.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/mall/storeshop/alterAd.vue
// module id = 1188
// module chunks = 0